var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 17,
  viewBox: "0 0 24 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.6 8.286H1m14.4 7.284 7.2-7.284L15.4 1",
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgNext as ReactComponent };
export default __webpack_public_path__ + "assets/media/next.c76d5b44293a0d7c8181bdf71d29f348.svg";